export default [
	{
		brand: "cheque",
		card: 0,
		name: "Chèque Déjeuner",
		order: 1,
		paper: 1,
		perso: true,
	},
	{
		brand: "dejun",
		card: 11,
		order: 1,
		name: "go for Eat",
		paper: 0,
		perso: true,
	},
	// {
	// 	brand: "cadou",
	// 	card: 0,
	// 	order: 2,
	// 	name: "Cadhoc",
	// 	paper: 2,
	// 	perso: true,
	// },
	{
		brand: "cadou",
		card: 12,
		order: 2,
		name: "Gift",
		paper: 0,
		perso: true,
	},
	{
		brand: "rewards",
		card: 12,
		order: 3,
		name: "Rewards",
		paper: 0,
		perso: true,
	},
	{
		brand: "vacanta",
		card: 13,
		order: 4,
		name: "Holidays",
		paper: 0,
		perso: true,
	},
];
